import { useState } from 'react';
import { Box, Typography } from '@mui/material';

export const DeemingCountdownBar = ({ startDate, thresholdDays = 90 }: { startDate: string; thresholdDays?: number }) => {
  const [now] = useState(() => Date.now());
  const start = new Date(startDate).getTime();
  const elapsed = now - start;
  const elapsedDays = Math.floor(elapsed / (1000 * 60 * 60 * 24));
  const pctElapsed = Math.max(0, Math.min(100, (elapsedDays / thresholdDays) * 100));
  const daysRemaining = thresholdDays - elapsedDays;

  const getColor = () => {
    if (daysRemaining <= 0) return 'error';
    if (daysRemaining <= 30) return 'warning';
    if (daysRemaining <= 60) return 'info';
    return 'success';
  };

  const getRiskLabel = () => {
    if (daysRemaining <= 0) return 'Critical';
    if (daysRemaining <= 30) return 'High';
    if (daysRemaining <= 60) return 'Medium';
    return 'Low';
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 140 }}>
      <Box sx={{ flex: 1, position: 'relative' }}>
        <Box sx={{ height: 8, bgcolor: 'grey.200', borderRadius: 1, overflow: 'hidden' }}>
          <Box
            sx={{
              width: `${pctElapsed}%`,
              height: '100%',
              bgcolor: `${getColor()}.main`,
              borderRadius: 1,
              transition: 'width 0.3s ease',
            }}
          />
        </Box>
        <Box sx={{ position: 'absolute', left: '50%', top: -2, transform: 'translateX(-50%)' }}>
          <Typography variant="caption" sx={{ fontSize: 8, color: 'text.secondary' }}>{thresholdDays}d</Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <Typography variant="caption" sx={{ color: `${getColor()}.main`, fontWeight: 600, lineHeight: 1 }}>
          {daysRemaining <= 0 ? 'Deemed' : `${daysRemaining}d left`}
        </Typography>
        <Typography variant="caption" sx={{ fontSize: 9, color: 'text.secondary', lineHeight: 1 }}>
          {getRiskLabel()} Risk
        </Typography>
      </Box>
    </Box>
  );
};
